export enum PlaybookEventType {
  PluginConnectivityFailure = 'PluginConnectivityFailure',
  ControlStatusChanged = 'ControlStatusChanged',
  UarStatusChanged = 'UarStatusChanged',
  ControlOwnerUpdated = 'ControlOwnerUpdated',
  RequirementOwnerChanged = 'RequirementOwnerChanged',
  RequirementStatusChanged = 'RequirementStatusChanged',
  EvidenceGapDetected = 'EvidenceGapDetected',
  RiskAdded = 'RiskAdded',
  RiskPlanUpdated = 'RiskPlanUpdated',
  RiskApproved = 'RiskApproved',
  RiskLevelUpdated = 'RiskLevelUpdated',
  EvidenceCollectionFailed = 'EvidenceCollectionFailed',
  FrameworkAuditEnded = 'FrameworkAuditEnded',
}

export enum PlaybookEventCategory {
  Plugin = 'plugin',
  control = 'control',
  UserAccessReview = 'user access review',
  Requirement = 'requirement',
  Evidence = 'evidence',
  Risk = 'risk',
  Audit = 'audit',
  Framework = 'framework',
}

export enum FieldType {
  Attributes = 'attributes',
  Comment = 'comment',
  Richtext = 'richtext',
  Enum = 'enum',
  Service = 'services',
  UserId = 'UserId',
  UserEmail = 'UserEmail',
  Framework = 'framework',
  Control = 'control',
  ControlStatus = 'ControlStatus',
  RiskLevel = 'RiskLevel',
  String = 'str',
  URL = 'url',
  EvidenceId = 'EvidenceId',
  UarStatus = 'UarStatus',
  ServiceInstanceId = 'ServiceInstanceId',
  RequirementStatus = 'RequirementStatus',
  UsersFromPlugin = 'UsersFromPlugin',
  DynamicCollaboration = 'form_description',
  EntityToCommentOn = 'entity_to_comment_on',
  MultiEmails = 'multi_emails',
}

export interface Field {
  field_id?: string;
  type?: FieldType;
  single_selection?: boolean;
  values?: string[];
  display_name?: string;
  field_description?: string;
  is_required?: boolean;
  features?: string[];
  depends_on?: string;
  is_filter?: boolean;
  operator_text?: string;
  disabled?: boolean;
}

export interface PlaybookTriggerFilterField extends Field {
  priority?: number;
  is_filterable?: boolean;
  aql_operator?: string;
  operator_text?: string;
  depends_on?: string;
}

export interface PaybookEvent {
  is_available?: boolean;
  event_type?: PlaybookEventType;
  event_text?: string;
  category?: PlaybookEventCategory;
  event_fields?: PlaybookTriggerFilterField[];
  supported_actions?: PlaybookActionType[];
  coming_soon_actions?: PlaybookActionType[];
}

export enum PlaybookActionType {
  Webhook = 'webhook',
  CommentTriggeredControl = 'comment_triggered_control',
  CommentSpecificControl = 'comment_specific_control',
  CommentTriggeredRisk = 'comment_triggered_risk',
  ChangeControlStatus = 'change_control_status',
  Notify = 'notify',
  CreateTask = 'create_task',
  CreateComment = 'create_comment',
  SendEmail = 'send_email',
}

export enum PlaybookActionCategory {
  AddComment = 'ADD_COMMENT',
}

export interface PlaybookAction {
  action_fields?: Field[];
  action_type?: PlaybookActionType;
  coming_soon?: boolean;
  action_text?: string;
  action_category?: PlaybookActionCategory;
  action_value_fields?: Field[];
}
